/**
 * Central chart color definitions.
 *
 * `chartPalette` mirrors the shadcn tokens --chart-1..5 (blue scale) declared
 * in src/styles/tokens.scss. Hex values are required because ECharts /
 * ApexCharts / Chart.js render to canvas and cannot resolve CSS variables.
 * Keep these in sync with the tokens when they change.
 */

/* --chart-1..5 hex equivalents (light → dark blue) */
export const chartPalette = [
    "#93c5fd", // --chart-1 oklch(0.809 0.105 251.813)
    "#3b82f6", // --chart-2 oklch(0.623 0.214 259.815)
    "#2563eb", // --chart-3 oklch(0.546 0.245 262.881)
    "#1d4ed8", // --chart-4 oklch(0.488 0.243 264.376)
    "#1e40af", // --chart-5 oklch(0.424 0.199 265.638)
];

/**
 * Read a CSS custom property from :root (respects the active theme).
 * Falls back when the variable is missing or when running outside a browser.
 *
 * getCssVar("--chart-2", "#3b82f6")
 */
export function getCssVar(name, fallback = "") {
    if (typeof window === "undefined" || !document.documentElement) {
        return fallback;
    }
    const value = getComputedStyle(document.documentElement)
        .getPropertyValue(name)
        .trim();
    return value || fallback;
}

/** Resolve --chart-1..5 at runtime (with the hex palette as fallback). */
export function getChartPalette() {
    return chartPalette.map((fallback, index) =>
        getCssVar(`--chart-${index + 1}`, fallback),
    );
}

/* Semantic series colors (revenue / margin / cost ...) used across the
   financial dashboards. */
export const chartColors = {
    revenue: "#2b7fff",
    revenue_2: "#00a6f4",
    revenue_light: "#38bdf8",
    revenue_deep: "#1c398e",
    margin: "#00c950",
    margin_2: "#00bc7d",
    margin_light: "#05df72",
    negative: "#fb2c36",
    negative_2: "#ffa2a2",
    cost: "#ff6900",
    cost_2: "#fe9a00",
    cost_light: "#fcd34d",
    slate_light: "#9CA3AF",
};
